import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WorkflowTaskFailure, IntegrationFailuresService } from '../tokens/integration-failures.token';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-only implementation of `IntegrationFailuresService`.
 *
 * Calls GET / POST /services/embedded/api/master-admin/integration-failures via HttpClient.
 * Rule 07 / Rule 10 — no mock fallback. Playwright tests intercept via `page.route()`.
 *
 * Authority required: ROLE_MASTER_ADMIN (enforced server-side and by roleGuard on the route).
 */
@Injectable()
export class IntegrationFailuresRestService implements IntegrationFailuresService {
  private readonly http = inject(HttpClient);

  list(status?: string, applicationId?: number, externalSystem?: string): Observable<WorkflowTaskFailure[]> {
    let params = new HttpParams();
    if (status) { params = params.set('status', status); }
    if (applicationId != null) { params = params.set('applicationId', String(applicationId)); }
    if (externalSystem) { params = params.set('externalSystem', externalSystem); }
    return this.http.get<WorkflowTaskFailure[]>(API_PATHS.INTEGRATION_FAILURES, { params });
  }

  retry(id: number): Observable<WorkflowTaskFailure> {
    return this.http.post<WorkflowTaskFailure>(`${API_PATHS.INTEGRATION_FAILURES}/${id}/retry`, null);
  }

  /** EM-1833 — close the row by hand; the backend records the actor and this reason on it. */
  resolve(id: number, reason: string): Observable<WorkflowTaskFailure> {
    return this.http.post<WorkflowTaskFailure>(`${API_PATHS.INTEGRATION_FAILURES}/${id}/resolve`, { reason });
  }
}
